// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

// Named theme for the simplified client UI only. The default ('light') theme is
// left untouched so the existing admin/reseller UI stays visually identical.
const clientTheme = {
  dark: false,
  colors: {
    primary: '#1867C0',   // brand blue
    secondary: '#5E35B1', // indigo/purple accent
    accent: '#5E35B1',
    success: '#2E7D32',
    warning: '#F59E0B',
    error: '#D32F2F',
    info: '#1867C0',
    background: '#F5F7FB',
    surface: '#FFFFFF',
  },
}

export default createVuetify({
  theme: {
    themes: {
      client: clientTheme,
    },
  },
})
